import React from "react";
import { Card } from "react-bootstrap";
import { FiClock, FiCalendar } from "react-icons/fi";
import { IoArrowUp, IoArrowDown } from "react-icons/io5";

export default function HoursStatCard({
  type,
  value,
  total,
  title,
  percent,
  trend
}) {

const iconMap = {
  today: <FiClock />,
  week: <FiClock />,
  month: <FiCalendar />,
  overtime: <FiCalendar />
};

const bgMap = {
  today: "icon-orange",
  week: "icon-dark",
  month: "icon-blue",
  overtime: "icon-pink"
};

const trendIcon =
trend === "up"
? <span className="trend-circle up"><IoArrowUp/></span>
: <span className="trend-circle down"><IoArrowDown/></span>;

return (

<Card className="hours-card h-100">

<Card.Body>

{/* ICON */}

<div className={`icon-box ${bgMap[type] || "icon-orange"}`}>
{iconMap[type] || <FiClock />}
</div>

{/* VALUE */}

<h2 className="hours-value">
{value} <span>/ {total}</span>
</h2>

{/* TITLE */}

<p className="hours-title">{title}</p>

{/* DIVIDER */}

<div className="divider"></div>

{/* TREND */}

<div className="trend-row">

{trendIcon}

<span className="trend-text">
{percent}
</span>

</div>

</Card.Body>


<style>{`

.hours-card{
border:1px solid #e5e7eb;
border-radius:10px;
background:#fff;
transition:0.2s;
}

.hours-card:hover{
box-shadow:0 4px 12px rgba(0,0,0,0.05);
}

.hours-card .card-body{
padding:18px;
}

/* ICON */

.icon-box{
width:32px;
height:32px;
border-radius:6px;
display:flex;
align-items:center;
justify-content:center;
color:#fff;
font-size:16px;
margin-bottom:12px;
}

.icon-orange{background:#ff6b2c;}
.icon-dark{background:#1f2937;}
.icon-blue{background:#3b82f6;}
.icon-pink{background:#ec4899;}

/* VALUE */

.hours-value{
font-size:28px;
font-weight:700;
color:#0f172a;
margin-bottom:4px;
}

.hours-value span{
font-size:20px;
font-weight:500;
color:#64748b;
}

/* TITLE */

.hours-title{
font-size:15px;
color:#64748b;
margin-bottom:14px;
}

/* DIVIDER */

.divider{
height:1px;
background:#e5e7eb;
margin-bottom:12px;
}

/* TREND */

.trend-row{
display:flex;
align-items:center;
gap:8px;
font-size:14px;
}

.trend-circle{
width:22px;
height:22px;
border-radius:50%;
display:flex;
align-items:center;
justify-content:center;
color:#fff;
font-size:12px;
}

.trend-circle.up{
background:#22c55e;
}

.trend-circle.down{
background:#ef4444;
}

.trend-text{
color:#64748b;
}

`}</style>

</Card>

)

}